var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D32F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7969 33.0664H18.0721C16.5578 33.0664 15.4329 31.6642 15.7614 30.1859L16.303 27.7493C16.719 25.8771 18.3794 24.5452 20.2972 24.5452H21.6119C21.6862 24.5452 21.7451 24.6079 21.7404 24.6821C21.6168 26.6601 23.1878 28.3324 25.1698 28.3324H25.6731C27.6891 28.3324 29.3235 26.6981 29.3235 24.6821C29.3235 24.6065 29.3848 24.5452 29.4604 24.5452H30.5242C32.5428 24.5452 34.2454 26.0482 34.4958 28.0512L34.5309 28.3324",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0348 18.1543C30.0348 19.8555 29.3497 21.3994 28.3767 22.518C27.3993 23.6418 26.1574 24.3085 25.064 24.3085C23.9706 24.3085 22.7288 23.6418 21.7513 22.518C20.7783 21.3994 20.0933 19.8555 20.0933 18.1543C20.0933 16.4223 20.5003 14.8796 21.319 13.7762C22.1308 12.6819 23.361 12 25.064 12C26.767 12 27.9972 12.6819 28.8091 13.7762C29.6277 14.8796 30.0348 16.4223 30.0348 18.1543Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8027 14.2444C20.2288 13.8694 19.5205 13.6567 18.6724 13.6567C15.9288 13.6567 14.6484 15.8822 14.6484 18.6275C14.6484 20.7931 16.0142 22.6352 17.4889 23.3166",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3296 16.7342C21.7498 17.1287 25.0163 17.3969 26.7205 15.314C27.6674 16.4975 29.3243 16.4186 29.561 16.2608",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3056 22.6514C13.3955 22.9285 11.0613 25.1766 10.675 28.0742L10.507 29.3337C10.4441 29.8061 10.8115 30.2258 11.2881 30.2258H15.3588",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5327 30.8225V35.3101",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2876 33.0667H36.7752",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.0d927b3d5dc12fde118228ea8726c69f.svg";
export { ForwardRef as ReactComponent };